import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  border-bottom: 2px solid ",
        ";\n  overflow-x: scroll;\n  padding: ",
        ";\n\n  ::-webkit-scrollbar {\n    display: none;\n  }\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none; /* Firefox */\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  justify-content: space-between;\n\n  & > button + button {\n    margin-left: ",
        ";\n  }\n\n  & > button {\n    flex-grow: ",
        ";\n  }\n\n  ",
        " {\n    flex-grow: ",
        ";\n  }\n\n  flex-grow: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { cloneElement, Children } from "react";
import styled from "styled-components";
import Flex from "../Box/Flex";
var Wrapper = styled(Flex).withConfig({
    componentId: "sc-28993f86-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.input;
}, function(param) {
    var fullWidth = param.fullWidth;
    return fullWidth ? 0 : "16px";
});
var Inner = styled(Flex).withConfig({
    componentId: "sc-28993f86-1"
})(_templateObject1(), function(param) {
    var gap = param.gap;
    return gap || "4px";
}, function(param) {
    var fullWidth = param.fullWidth;
    return fullWidth ? 1 : 0;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, function(param) {
    var fullWidth = param.fullWidth;
    return fullWidth ? 1 : 0;
}, function(param) {
    var fullWidth = param.fullWidth;
    return fullWidth ? 1 : 0;
});
var ButtonMenu = function(param) {
    var _param_activeIndex = param.activeIndex, activeIndex = _param_activeIndex === void 0 ? 0 : _param_activeIndex, onItemClick = param.onItemClick, children = param.children, fullWidth = param.fullWidth, gap = param.gap, _param_isColorInverse = param.isColorInverse, isColorInverse = _param_isColorInverse === void 0 ? false : _param_isColorInverse;
    return /*#__PURE__*/ _jsx(Wrapper, {
        p: [
            "0 4px",
            "0 16px"
        ],
        fullWidth: fullWidth,
        children: /*#__PURE__*/ _jsx(Inner, {
            fullWidth: fullWidth,
            gap: gap,
            children: Children.map(children, function(child, index) {
                var isActive = activeIndex === index;
                var color = isActive ? "backgroundAlt" : "textSubtle";
                var inverseColor = isActive ? "textSubtle" : "backgroundAlt";
                var backgroundColor = isActive ? "textSubtle" : "input";
                var inverseBackgroundColor = isActive ? "input" : "textSubtle";
                return /*#__PURE__*/ cloneElement(child, {
                    isActive: isActive,
                    onClick: onItemClick ? function() {
                        return onItemClick(index);
                    } : undefined,
                    color: isColorInverse ? inverseColor : color,
                    backgroundColor: isColorInverse ? inverseBackgroundColor : backgroundColor
                });
            })
        })
    });
};
export default ButtonMenu;
